import { useParams } from "react-router-dom";
import Title from "../../../components/Title";
import SimpleProgramStats from "../program/SimpleProgramStats";
import CollapsingSection from "../../../components/CollapsingSection";
import SessionsChart from "./SessionsChart";
import EnrollmentsChart from "./EnrollmentsChart";
import ActivitiesChart from "./ActivitiesChart";

export default function ProgramStatistics() {

    const { id } = useParams()

    return(<div className="standard-padding page-xl-centered showing">
        <Title className={'v-spacer-xs'}>Program Statistics</Title>
        <SimpleProgramStats programId={id} isDetailed={true}/>
        <div className="v-spacer-xs"></div>
        <div className="card standard-padding-s v-spacer-xs">
            <CollapsingSection title={'Enrollments'}>
                <EnrollmentsChart programId={id}/>
            </CollapsingSection>
        </div>
        <div className="card standard-padding-s v-spacer-xs">
            <CollapsingSection title={'Rate of Completed Activities'}>
                <ActivitiesChart programId={id}/>
            </CollapsingSection>
        </div>
        <div className="card standard-padding-s v-spacer-xs">
            <CollapsingSection title={'Rate of Completed Sessions'}>
                <SessionsChart programId={id}/>
            </CollapsingSection>
        </div>
    </div>)
}
